<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">Template Behavior</div>
  </div>
  <div class="card-body">
    <div class="container">
      <form class="form" [formGroup]="behaviorForm">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>API Type</mat-label>
          <mat-select formControlName="primary_source_system">
            <mat-option value="Pharmacy System">Pharmacy System</mat-option>
            <mat-option value="3rd Party Application">3rd Party Application</mat-option>
            <mat-option value="Knostos">Knostos</mat-option>
            <mat-option value="Other">Other</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>Source Description</mat-label>
          <textarea
            matInput
            formControlName="source_description"
            rows="5"
            maxlength="499"
          ></textarea>
        </mat-form-field>
        <div class="row">
          <mat-form-field appearance="fill" class="mat-form-field-fluid col-6">
            <mat-label>Frequency</mat-label>
            <input matInput formControlName="frequency_time" type="number" min="1" />
          </mat-form-field>
          <mat-form-field appearance="fill" class="mat-form-field-fluid col-6">
            <mat-label>Interval</mat-label>
            <mat-select formControlName="frequency_type">
              <mat-option value="seconds">Seconds</mat-option>
              <mat-option value="minutes">Minutes</mat-option>
              <mat-option value="hours">Hours</mat-option>
              <mat-option value="days">Days</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>Task Activation</mat-label>
          <textarea matInput formControlName="task_activation" rows="5" maxlength="499"></textarea>
        </mat-form-field>
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Update Condition </mat-label>
          <input matInput formControlName="update_condition" />
        </mat-form-field>
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>URL Request Ticket</mat-label>
          <div class="row">
            <div class="col-11">
              <input
                matInput
                type="url"
                formControlName="url_request_ticket"
                placeholder="ex: https://example.com"
                (focusout)="validateUrl()"
              />
            </div>
            <div *ngIf="showExternalLinkIcon()" class="col-1">
              <i class="fas fa-external-link-alt" (click)="openExternalLink()"></i>
            </div>
          </div>
          <mat-error *ngIf="isControlHasError('url_request_ticket', 'pattern')">
            Invalid URL
          </mat-error>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button class="mr-2" mat-raised-button color="primary" (click)="save()">Save</button>
        <button mat-button mat-dialog-close="true" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>
